<template>
  <div class="upload_box">
    <el-upload class="avatar-uploader" action="/fileServer/upload" :data="{id,uploadTime}" :show-file-list="false" :on-success="onSuccessUpload"
               :before-upload="onBeforeUpload">
      <img v-if="showUrl" :src="showUrl" class="avatar" />
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
  </div>
</template>

<script>
import SparkMD5 from "spark-md5";
export default {
  props: {
    showUrl: "",
  },
  data() {
    return {
      id: "", //文件上传id，需要md5加密图片得到
      uploadTime: "",
    };
  },
  methods: {
    asyncMd5(file) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.name = file.name;
        fileReader.readAsArrayBuffer(file);
        fileReader.onload = (e) => {
          let spark = new SparkMD5.ArrayBuffer();
          spark.append(e.target.result);
          resolve(spark.end());
        };
        fileReader.onerror = (e) => {
          reject(e);
        };
      });
    },
    async onBeforeUpload(e) {
      console.log(e);
      try {
        let id = await this.asyncMd5(e);
        this.id = id;
        this.uploadTime = this.getDateTime();
        console.log(this.id);
        console.log(this.uploadTime);
        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    },
    getDateTime() {
      let date = new Date();
      let time =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1 > 9
          ? date.getMonth() + 1
          : "0" + (date.getMonth() + 1)) +
        "-" +
        (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
        " " +
        (date.getHours() > 9 ? date.getHours() : "0" + date.getHours()) +
        ":" +
        (date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes()) +
        ":" +
        (date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds());
      return time;
    },
    onSuccessUpload(e) {
      this.$emit("success", e);
    },
  },
};
</script>

<style lang="less" scoped>
.upload_box {
  display: inline-block;
  /deep/ .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    text-align: center;
  }
  .avatar-uploader-icon svg {
    margin-top: 74px; /* (178px - 28px) / 2 - 1px */
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/audit/components/upload.vue